import { AxiosRequestConfig } from 'axios'
import merge from 'lodash/merge'

export interface Config {
  api: AxiosRequestConfig
}

const config = merge({
  api: {
    baseURL: 'https://recette.stmarceautt.fr'
  }
}, (window as any).config) as Config

export default config
